/* /!\ values are tied to translations */
export enum PageActions {
  CHECKOUT = 'checkout',
  BOOK_TOUR = 'book-tour',
  BOOK_SPACE = 'book-space',
  BROKER_FORM = 'broker-form',
  INQUIRY_LANDLORD = 'inquiry-landlord',
  LINK = 'link',
  EXTERNAL_LINK = 'external-link',
  BOOK_MEETING_ROOM = 'book-meeting-room',
  MEETING_ROOM_SPECIAL_REQUEST = 'meeting-room-special-request',
  PURCHASE_COWORKING_DAY_PASS = 'purchase-coworking-day-pass',
}

export enum Orientations {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
